import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { getCustomOptionValues, getCustomOptionPriceDelta } from '@vue-storefront/core/modules/catalog/helpers/customOption'
import { getBundleOptionsValues, getBundleOptionPrice, getSelectedBundleOptions } from '@vue-storefront/core/modules/catalog/helpers/bundleOptions'
import { isSpecialPriceActive } from '@vue-storefront/core/modules/catalog/helpers/taxCalc'
import { getBundleOptionsMinPrices } from '@vue-storefront/core/modules/catalog/helpers/bundleOptions'
// @ts-ignore
import { round } from 'mathjs'

export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    customOptions: {
      type: Object,
      default: () => ({})
    },
    omnibusPrice: {
      type: Number,
      default: 0
    }
  },
  computed: {
    bundleSpecialMinPrice () { // bundle special min price
      const bundleSpecialPrice = this.product.original_special_price / 100 || 0
      return bundleSpecialPrice && isSpecialPriceActive(this.product.special_from_date, this.product.special_to_date)
        ? getBundleOptionsMinPrices(this.product, this.product.price_type).map(optionPrice => round(optionPrice * bundleSpecialPrice, 2)).reduce((memo, current) => memo + current, 0)
        : 0
    },
    specialPrice () {
      return this.bundleSpecialMinPrice || Number(this.price.special.toFixed(2))
    },
    originalPrice () {
      return this.price.original || this.price.default
    },
    saleDifference () {
      if ((!this.initialPrice.special || !this.price.default || !this.price.original) && !this.bundleSpecialMinPrice) return null
      let diff = this.omnibusPrice - this.specialPrice
      if (diff <= 0) return
      diff = this.$options.filters.price(diff)
      let diffPercent = (100 - (this.specialPrice / this.omnibusPrice * 100)).toFixed(2)
      return this.$t('You save ') + diffPercent + '% (' + diff + ').'
    },
    saleDifferenceSmall () {
      if ((!this.initialPrice.special || !this.price.default || !this.price.original) && !this.bundleSpecialMinPrice) return null
      let diff = this.omnibusPrice - this.specialPrice
      if (diff <= 0) return null
      diff = this.$options.filters.price(diff)
      return this.$t('You save ') + diff
    },
    saleDifferenceAlternativeSmall () {
      if (!this.product.promo_price || !this.originalPrice) return null
      let diff = this.originalPrice - this.product.promo_price
      diff = this.$options.filters.price(diff)
      return this.$t('You save ') + diff
    },
    saleDifferenceAlternative () {
      if (!this.product.promo_price || !this.originalPrice) return null
      let diff = this.originalPrice - this.product.promo_price
      diff = this.$options.filters.price(diff)
      let diffPercent = (100 - (this.product.promo_price / this.originalPrice * 100)).toFixed()
      return this.$t('You save ') + diffPercent + '% (' + diff + ').'
    },
    bundleOptionsPrice () {
      const allBundeOptions = this.product.bundle_options || []
      const selectedBundleOptions = getSelectedBundleOptions(this.product)
      const price = getBundleOptionPrice(
        getBundleOptionsValues(selectedBundleOptions, allBundeOptions),
        this.product.price_type
      )
      return price
    },
    customOptionsPriceDelta () {
      const priceDelta = getCustomOptionPriceDelta(
        getCustomOptionValues(Object.values(this.omnibusPrice), this.product.custom_options || []),
        this.product
      )

      return priceDelta
    },
    price () {
      const customOptionPrice = this.customOptionsPriceDelta.priceInclTax
      const special = (this.initialPrice.default + customOptionPrice) * this.product.qty
      const original = (this.initialPrice.original + customOptionPrice) * this.product.qty
      const defaultPrice = this.product.qty > 0
        ? (this.initialPrice.default + customOptionPrice) * this.product.qty
        : this.initialPrice.default

      if (this.bundleOptionsPrice.priceInclTax > 0) {
        return {
          special,
          original,
          default: this.bundleOptionsPrice.priceInclTax
        }
      }

      return {
        special,
        original,
        default: defaultPrice
      }
    },
    initialPrice () {
      return {
        default: this.product.price_incl_tax || this.product.priceInclTax || 0,
        original: this.product.original_price_incl_tax || this.product.originalPriceInclTax || 0,
        special: this.product.special_price || this.product.specialPrice || 0
      }
    },
    storeView () {
      return currentStoreView()
    }
  }
}
